import React, { Component, lazy, Suspense } from 'react'
import './CustomerPages.css'
import '../Admin.css'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import RouteGuard from '../../core/guard/RouteGuard'
import { LazyLoader } from '../../Util/helper'
import AdminPage from '../Admin/AdminCore';
import TicketPrint from '../Admin/Components/AdminEvents/Ticketprint'
import AdminRedirect from './AdminRedirect'
const LoginPage = lazy(() => import('../Login/Login'));
const PortalPage = lazy(() => import('../Portal/PortalCore'));
const ResetPasswordPage = lazy(() => import('../Login/Components/ResetPassword/ResetPassword'));

export default class CustomerPages extends Component {
	render() {
		return (
			<Suspense fallback={<LazyLoader />}>
				<Router>
					<Switch>
						<Route exact path="/">
							<AdminRedirect />
						</Route>

						<Route path='/admin'>
							<RouteGuard Component={AdminPage} key="guard-admin" />
						</Route>
						<Route path='/portal'>
							<RouteGuard Component={PortalPage} key="guard-portal" />
						</Route>
						{/* <Route path='/driver' component={Driver} /> */}
						<Route path="/login">
							<LoginPage />
						</Route>
						<Route path="/reset-password/:token" render={(props) => (
							<ResetPasswordPage token={props.match.params.token} />
						)}>
						</Route>
						<Route path="/print">
							<TicketPrint />
						</Route>
					</Switch>
				</Router>
			</Suspense>
		)
	}
}
